module.exports = __webpack_public_path__ + "static/media/herawan.3a7323b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/herawan.png
// module id = 1650
// module chunks = 0